import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/mining/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/mining/add',
      data,
      dataType: 'form'
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/mining/update',
      data,
      dataType: 'form'
    });
  },
  remove(data) {
    return http.post({
      url: '/la/admin/mortgage/scale/delete',
      data,
      dataType: 'form'
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  }
};
